import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const BillingSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-xl border border-emerald-200 bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-emerald-700">Payment Successful</h1>
        <p className="mt-2 text-sm text-gray-600">
          Your checkout has completed successfully.
        </p>

        <div className="mt-4 rounded-lg bg-emerald-50 border border-emerald-100 p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-emerald-700">
            Stripe Session ID
          </p>
          <p className="mt-1 break-all text-sm text-gray-800">
            {sessionId || "Not provided"}
          </p>
        </div>

        <div className="mt-6 flex gap-3">
          <Link
            to="/merchant/my-plan"
            className="inline-flex items-center justify-center rounded-md bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700"
          >
            Go to My Plan
          </Link>
          <Link
            to="/merchant/home"
            className="inline-flex items-center justify-center rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BillingSuccessPage;
